const SEPARATOR = Buffer.from('::').toString('hex');

export { SEPARATOR };
